import React, { useRef, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Grid, Html } from '@react-three/drei';

export default function RobotDesigner({ parts, selectedPartType, onChangeParts }) {
  const [hovered, setHovered] = useState(null);
  const [active,  setActive]  = useState(null);

  // place new part
  const handlePlace = e => {
    if (!selectedPartType) return;
    e.stopPropagation();
    const { x, z } = e.point;
    onChangeParts([
      ...parts,
      {
        id: Date.now(),
        type: selectedPartType,
        position: [Math.round(x), 0.5, Math.round(z)],
        rotation: [0,0,0],
        scale: 1,
        color: ({
          Body:   '#777',
          Wheel:  '#222',
          Arm:    '#c00',
          Sensor: '#006'
        })[selectedPartType]
      }
    ]);
  };

  // update part
  const updatePart = (id, patch) =>
    onChangeParts(parts.map(p => p.id===id ? { ...p, ...patch } : p));

  // delete part
  const deletePart = id =>
    onChangeParts(parts.filter(p=>p.id!==id));

  return (
    <Canvas style={{ height: 400 }}>
      <ambientLight intensity={0.5}/>
      <directionalLight position={[5,5,5]}/>
      <Grid args={[20,20]} />

      {/* invisible ground to catch clicks */}
      <mesh 
        rotation-x={-Math.PI/2} 
        onClick={handlePlace}
      >
        <planeGeometry args={[20,20]}/>
        <meshBasicMaterial transparent opacity={0}/>
      </mesh>

      {parts.map(p => (
        <mesh
          key={p.id}
          position={p.position}
          rotation={p.rotation}
          scale={p.scale}
          onPointerOver={e=>{ e.stopPropagation(); setHovered(p.id); }}
          onPointerOut ={e=>{ setHovered(null); }}
          onClick={e=>{ e.stopPropagation(); setActive(p.id); }}
        >
          <boxGeometry args={[1,1,1]}/>
          <meshStandardMaterial color={p.color}/>
          
          {active===p.id &&
            <Html center distanceFactor={10}>
              <div style={{
                background:'#fff',padding:8,borderRadius:4,boxShadow:'0 0 5px rgba(0,0,0,0.3)'
              }}>
                <strong>{p.type}</strong><br/>
                <label>
                  Rotate Y: 
                  <input
                    type="range" min={0} max={360}
                    value={p.rotation[1]}
                    onChange={e=> updatePart(p.id, {
                      rotation: [0, Number(e.target.value)*Math.PI/180, 0]
                    })}
                  />
                </label>
                <br/>
                <label>
                  Scale: 
                  <input
                    type="range" min={0.5} max={2} step={0.1}
                    value={p.scale}
                    onChange={e=> updatePart(p.id, {
                      scale: Number(e.target.value)
                    })}
                  />
                </label>
                <br/>
                <button onClick={()=>deletePart(p.id)}
                        style={{ color:'red', marginTop:4 }}>
                  Delete
                </button>
              </div>
            </Html>
          }
        </mesh>
      ))}

      <OrbitControls />
    </Canvas>
  );
}
